import Vue from 'vue'
import VueI18n from 'vue-i18n'

import { getLanguage } from '../utils/cookies.js'

import elementEnLocale from 'element-ui/lib/locale/lang/en.js'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN.js'

// User defined lang
import en from './en.json'
import zhCn from './zh-cn.json'
Vue.use(VueI18n)

const messages = {
  'en': {
    ...en,
    ...elementEnLocale

  },
  'zh-cn': {
    ...zhCn,
    ...elementZhLocale
  },
}


const i18n = new VueI18n({
  locale: getLanguage() || 'en',//getLocale(),
  messages
})

export default i18n
